export default __webpack_public_path__ + "static/media/Metallic-Paints.d6409218.jpg";